import setCommonHeaders from '@/src/utils/rtkQuery/setCommonHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Kept for the disabled endpoint above.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface AbApiResponse {
    [key: string]: string
}

export const abApi = createApi({
    reducerPath: 'abApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '',
        prepareHeaders: (headers, api) => {
            return setCommonHeaders(headers)
        }
    }),

    tagTypes: ['abApi'],
    endpoints: builder => ({
        /*
         * Disabled: AB_CONFIG_STATIC in src/utils/abConfig stands in for this response, so the
         * browser no longer calls the endpoint either. Restore with the hook in
         * src/hooks/useSignInFlowVariant.
         *
         * getAbApiData: builder.query<AbApiResponse, void>({
         *     query: () => '/source/abtest/getflyinpwaconfig',
         *     providesTags: (result, error) => [{ type: 'abApi' }]
         * })
         */
    })
})

// export const { useGetAbApiDataQuery } = abApi

export default abApi
